import React, { useMemo } from "react";
import { Flex, Tag, Text } from "@jsq/ds/core";
import { Icon, IconType } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { PositionScreeningStatus } from "../../../../../graphql/supergraphEnums";
import { PositionScreeningStatus as PositionScreeningStatusType } from "../../../../../graphql/supergraphTypes";
import { amlStatusField, amlSubLabelDefaultTag } from "../styles_vanilla.css";
import { FieldLabel } from "./FieldLabel";
import { getNextCycleCountdown } from "./utils";

export const ScreeningStatus = ({
  screeningStatus,
}: {
  screeningStatus?: PositionScreeningStatusType | null;
}) => {
  const screeningStatusValue = useMemo(() => {
    if (screeningStatus == PositionScreeningStatus.IssuesDetected) {
      return "Issue detected";
    }
    return "No issues";
  }, [screeningStatus]);

  const iconSpecs = useMemo((): { type: IconType; color: Colors } => {
    if (screeningStatus == PositionScreeningStatus.IssuesDetected)
      return { type: "exclamation-triangle", color: Colors.Warning600 };
    return { type: "circle-check", color: Colors.Success600 };
  }, [screeningStatus]);

  return (
    <div className={amlStatusField}>
      <FieldLabel label="Screening status" />
      <Flex alignItems="center" gap={4}>
        <Icon type={iconSpecs.type} variant="outline" color={iconSpecs.color} />
        <Text variant="strong-lg">{screeningStatusValue}</Text>
      </Flex>
      <Tag variant="neutral" className={amlSubLabelDefaultTag}>
        <Icon type="clock" size="small" />
        {getNextCycleCountdown()}
      </Tag>
    </div>
  );
};
